import { slicedToArray as _slicedToArray } from '../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import { CouponContextProvider } from './external/CouponContext.js';
import { ImageMapBrazeContextProvider } from './external/ImageMapBrazeContext.js';
import { ImageMapShareContextProvider } from './external/ImageMapShareContext.js';
import { StoreItemsContextProvider } from './external/StoreItemsContext.js';
import { jsx } from '@emotion/react';
import { AccordionContextProvider } from './internal/AccordionContext.js';
import { BlockContextProvider } from './internal/BlockContext.js';
import { LinkContextProvider } from './internal/LinkContext.js';
import './internal/StickyContext.js';
import { StickyTabContextProvider } from './internal/StickyTabContext.js';
import { TabContextProvider } from './internal/TabContext.js';
import './internal/EditorContext.js';

function provider(provider, props) {
  return [provider, props];
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function ProviderComposer(props) {
  var _props$providers = props.providers,
    providers = _props$providers === void 0 ? [] : _props$providers,
    children = props.children;
  return jsx(React__default.Fragment, null, providers.reduceRight(function (acc, Comp) {
    var _Comp = _slicedToArray(Comp, 2),
      Provider = _Comp[0],
      value = _Comp[1];
    return jsx(Provider, {
      value: value
    }, acc);
  }, children));
}
function EditorComponentsProvider(_ref) {
  var contexts = _ref.contexts,
    children = _ref.children;
  var link = contexts.link,
    block = contexts.block,
    tab = contexts.tab,
    accordion = contexts.accordion,
    coupon = contexts.coupon,
    storeItems = contexts.storeItems,
    stickyTab = contexts.stickyTab,
    imageMapShare = contexts.imageMapShare,
    imageMapBraze = contexts.imageMapBraze;
  return jsx(ProviderComposer, {
    providers: [provider(LinkContextProvider, link), provider(BlockContextProvider, block), provider(TabContextProvider, tab), provider(AccordionContextProvider, accordion), provider(CouponContextProvider, coupon), provider(StoreItemsContextProvider, storeItems), provider(StickyTabContextProvider, stickyTab), provider(ImageMapShareContextProvider, imageMapShare), provider(ImageMapBrazeContextProvider, imageMapBraze)]
  }, children);
}

export { EditorComponentsProvider };
//# sourceMappingURL=EditorComponentsProvider.js.map
